<template>
    <div class="ssv-form">
        <template v-if="false === displayFullForm">
            <ssv-order-billing-information-ic-form v-bind="$props" :display-full-form="displayFullForm" v-on:displayFullFormControl="displayFullForm = true" v-if="!name"/>
            <ssv-order-billing-information-info :display-full-form="displayFullForm" v-on:displayFullFormControl="displayFullForm = true"/>
        </template>
        <template v-if="displayFullForm">
            <ssv-order-billing-information-ic-form v-bind="$props"/>
            <ssv-order-error-field field="billingInformation.icError"/>
            <div class="input-item">
                <label class="label" for="name">Název společnosti {{!required ? '(nepovinné)' : ''}}</label>
                <input class="input input--xl" type="text" id="name" v-model="name">
                <ssv-order-error-field field="billingInformation.name"/>
            </div>

            <div class="input-item">
                <label class="label" for="address">Adresa</label>
                <input class="input input--xl" type="text" id="address" v-model="address">
                <ssv-order-error-field field="billingInformation.address"/>
            </div>

            <div class="input-item__container">
                <div class="input-item">
                    <label for="city" class="city label">Město</label>
                    <input class="input input--l" type="text" id="city" v-model="city">
                    <ssv-order-error-field field="billingInformation.city"/>
                </div>

                <div class="input-item">
                    <label class="label" for="zip">PSČ</label>
                    <input class="input input--s" type="text" id="zip" v-model="zip">
                    <ssv-order-error-field field="billingInformation.zip"/>
                </div>
            </div>

            <div class="input-item">
                <label class="label" for="taxIdentificationNumber">DIČ (nepovinné)</label>
                <input class="input input--s" type="text" id="taxIdentificationNumber" v-model="taxIdentificationNumber"/>
            </div>
        </template>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import {mapFields} from 'vuex-map-fields';
    import SsvOrderErrorField from '../error/ErrorField';
    import SsvOrderErrorState from '../error/ErrorState';
    import SsvOrderBillingInformationIcForm from './BillingInformationIcForm';
    import SsvOrderBillingInformationInfo from "./BillingInformationInfo";

    export default {
        name:       'SsvOrderBillingInformationForm',
        components: {
            SsvOrderBillingInformationInfo,
            SsvOrderBillingInformationIcForm,
            SsvOrderErrorState,
            SsvOrderErrorField
        },
        props:      {
            required:        {
                type:    Boolean,
                default: false,
            },
            displayFullForm: {
                type:    Boolean,
                default: false
            },
            disableAres:     {
                type:    Boolean,
                default: false,
            },
            icOptional:     {
                type:    Boolean,
                default: false,
            },
        },
        data() {
            return {
                processing: false,
                error:      false,
            }
        },
        computed:   {
            ...mapFields('ssvOrder', [
                'billingInformation.name',
                'billingInformation.address',
                'billingInformation.zip',
                'billingInformation.city',
                'billingInformation.identificationNumber',
                'billingInformation.taxIdentificationNumber',
            ]),
        },
        methods:    {
            ...mapActions('ssvOrder', ['setError']),
            validate() {
                let isError = false;
                if ((!this.name || this.name.length === 0) && this.required) {
                    isError = true;
                    this.setError({
                        msg: 'Zadejte název společnosti',
                        key: 'billingInformation.name'
                    });
                }
                if (!this.zip || this.zip.length === 0) {
                    isError = true;
                    this.setError({
                        msg: 'Zadejte PSČ',
                        key: 'billingInformation.zip'
                    });
                }
                if (!this.address || this.address.length === 0) {
                    isError = true;
                    this.setError({
                        msg: 'Zadejte ulici',
                        key: 'billingInformation.address'
                    });
                }
                if (!this.city || this.city.length === 0) {
                    isError = true;
                    this.setError({
                        msg: 'Zadejte město',
                        key: 'billingInformation.city'
                    });
                }
                if ((!this.identificationNumber || this.identificationNumber.length === 0) && this.required && this.icOptional === false) {
                    isError = true;
                    this.setError({
                        msg: 'Zadejte IČ',
                        key: 'billingInformation.identificationNumber'
                    });
                }
                if (isError) {
                    this.displayFullForm = true;
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/billing-information/BillingInformationForm.vue